import { MicroView } from "../../View/AppView/MicroView";
import { ViewController, ModelUpdateEvent, TimeoutEvent, TimeUpdateEvent, MaintenanceEvent, ChannelSwitchEvent, ButtonClickEvent,
         PlaybackStartEvent, PlaybackStopEvent } from "@gaming/srvg-classes-core";
import { VideoViewController } from "./VideoViewController";
import { ChunkIndicatorViewController } from "./ChunkIndicatorViewController";
import { ChunkAreaViewController } from "./ChunkAreaViewController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";

export class MicroViewController extends ViewController {
    microView:MicroView;
    videoViewController:VideoViewController;
    chunkIndicatorViewController:ChunkIndicatorViewController;
    chunkAreaViewController:ChunkAreaViewController;
    videoStatus: string;

    constructor(options) {
        options = options || {};
        options.view = options.microView || null;
        super(options);

        this.microView = options.microView || null;

        this.videoStatus = 'stopped';

        /******************* initialize controllers ************************/


        this.videoViewController = this.addChildViewController( new VideoViewController( { videoView: this.microView.videoView } ) );


        this.chunkIndicatorViewController = this.addChildViewController(new ChunkIndicatorViewController({
            chunkIndicatorView: this.microView.chunkIndicatorView
        }));

        /*this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
         overlayView: this.webView.overlayContainerView,
         teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
         teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
         } ) );
         */
        this.chunkAreaViewController = this.addChildViewController(new ChunkAreaViewController({
            useChunkModel: true,
            chunkAreaView: this.microView.chunkAreaView
        }));

        /******************* connect components ************************/

        if (this.microView.chunkAreaView.chunkPickerView) {
            // FIXME move
            this.microView.chunkAreaView.selectedChunkModel.addSubscriberForEvent(
                app.customerIntegrationController,
                ModelUpdateEvent
            );
            if( app.inactivityController ) {
                app.inactivityController.addSubscriberForEvent(
                    this.chunkAreaViewController.chunkPickerViewController,
                    TimeoutEvent
                );
            }
        }

        app.timelineController.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        app.timelineController.addSubscriberForEvent(app.customerIntegrationController, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent(app.server, TimeUpdateEvent);
        app.timelineController.addSubscriberForEvent(this.chunkAreaViewController, ChunkRangeChangeEvent);
        app.timelineController.addSubscriberForEvent( this, PhaseChangeEvent );

        // subscribe all necessary controller and other for inactivity
        if( app.inactivityController ) {
            app.inactivityController.addSubscriberForEvent(app.server, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkIndicatorViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkAreaViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.microView, TimeoutEvent);
        }

        var exch = srvg.eventExchange;
        exch.addEventHandler(app.timelineController, 'all', ChannelSwitchEvent);

        exch.addEventHandler(app.customerIntegrationController, 'all', ChannelSwitchEvent);

        if( srvg.debugView ) {
            srvg.debugView.registerEventHandlers();
        }

        /******************* start components ************************/
        app.timelineController.startPolling();
        if( app.inactivityController ) {
            app.inactivityController.startWaiting();
        }
        app.customerIntegrationController.startCustomerActions();

        //this.videoViewController.play();

        this.microView.playButton.addSubscriberForEvent( this, ButtonClickEvent );

        this.microView.videoView.addSubscriberForEvent( this, PlaybackStartEvent );
        this.microView.videoView.addSubscriberForEvent( this, PlaybackStopEvent );
        this.microView.videoView.addSubscriberForEvent( this, ButtonClickEvent );

        if (srvg.featuresInstances.getDisableYoutubeVideo()){
            $('#videoContainer').addClass('disabledYoutubeVideo');
        }
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.microView.$domNode.attr('data-phase-name', event.phase.name);
    }

    handleButtonClickEvent( event:ButtonClickEvent, eventProvider ) {
        // console.log( 'handleButtonClickEvent', eventProvider.name );
        if( eventProvider == this.microView.videoView ) {
            if( this.videoStatus == 'playing' ) {
                this.microView.videoView.stop();
                $('#playbutton_container').show();
                this.videoStatus = 'stopped';
            }
        }
        else if( eventProvider == this.microView.playButton ) {
            if( this.videoStatus == 'stopped' ) {
                $('#playbutton_container').hide();
                if( this.microView.youtubeVideoView ) {
                    // playerclass playbutton handling
                    $('.playButtonWrapper').addClass('hidden').removeClass('enabled').removeAttr('style');
                    this.microView.youtubeVideoView.hide();
                    $('.playerclassOverlays').addClass('hidden');
                    if(!srvg.isMobile){
                        this.showPlayButtonPC();
                    }

                }
                $('#youtubevideo_container').hide();
                this.videoViewController.play();
                this.videoStatus = 'playing';
            }
            else if( this.videoStatus == 'paused' ) {
                this.microView.videoView.stop();
                //this.videoViewController.videoView.setPaused( true ); old version
                $('#playbutton_container').hide();
                this.videoStatus = 'playing';
            }
        }
    }

    // stop/disable all functions except of widgets and inactivitybutton
    // includes different states of videoStatus
    handleTimeoutEvent(event: TimeoutEvent, provider){
        setTimeout(function() {
            srvg.eventExchange.eventSubscriptions = []
        }, 2000);

        if( this.videoStatus == 'playing' ) {
            this.microView.videoView.stop();
            this.videoStatus = 'stopped';
        } else if( this.videoStatus == 'stopped' ) {
            $('#playbutton_container').css('display','none');
            if( this.microView.youtubeVideoView ) {
                this.microView.youtubeVideoView.hide(false);
                this.microView.youtubeVideoView.disable();
            }
            $('#youtubevideo_container').css('display','none');
            this.videoStatus = 'playing';
        } else if( this.videoStatus == 'paused' ) {
            this.microView.videoView.stop();
            $('#playbutton_container').css('display','none');
            this.videoStatus = 'playing';
        }
    }


    showPlayButtonPC(){

        var that = this;
        $('#videoView').on('click', function () {
            srvg.player.api.stop();
            $('.playerclassPoster').addClass('hidden');
            $('.playerclassPoster').removeClass('visible');
            $('#playbutton_container').show();
            setTimeout(()=> {
                $('#playbutton').on('click', () => {
                    setTimeout(() => {
                        that.hidePlayButtonPC()
                    }, 1000);
                })
            },500)

        });
    }


    hidePlayButtonPC(){

        $('#playbutton_container').hide();
        srvg.player.api.play();
        $('#playbutton').off(); // Delete all previously placed event listeners

    }
}